export const setAggregateData = (aggregateData) => {
    let tempAggregateData = [];
    aggregateData.forEach(data => {
        tempAggregateData.push({
            fieldName: data.fieldName,
            creditDropdown: data.creditWorthinessField.fieldName,
            fieldType: data.fieldType,
            fieldDirection: data.fieldDirection,
            fieldValue: [],
            fromDate: data.fromDate,
            toDate: data.toDate,
            id: (data.id) ? data.id : null
        })
    })
    return tempAggregateData;
}